import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="multi-select"
export default class extends Controller {

	static targets = [
		'selectedItemsLabel',
		'itemList',
		'itemInput',
		'resetButton',
	]

	static values = {
		pluralItemName:  { type: String,  default: 'Items' },
		blankIsAll:      { type: Boolean, default: true },
		searchIntent:    { type: Boolean, default: true },
		truncateLength:  { type: Number,  default: 28 }
	}

	connect() {
		this.selectionChanged()
		this.setClosedEventListener()
	}

	setSelectedItemsLabel() {
		const selectedItems = this.getSelectedItems()

		if (selectedItems.length == 0) {
			if (this.blankIsAllValue) {
				this.selectedItemsLabelTarget.innerHTML = `All ${this.pluralItemNameValue}`
			} else if (this.pluralItemNameValue == 'Selected') {
				this.selectedItemsLabelTarget.innerHTML = '&nbsp;'
			} else {
				this.selectedItemsLabelTarget.innerHTML = `No ${this.pluralItemNameValue}`
			}
			return
		}

		if (selectedItems.length == 1) {
			const selectedItem = selectedItems[0]

			let newLabel = ''
			const selectedItemNameElement = selectedItem.parentNode.querySelector('.selected-item-name')
			if (selectedItemNameElement) {
				this.selectedItemsLabelTarget.innerHTML = selectedItemNameElement.innerHTML
			} else {
				newLabel = selectedItem.parentNode.innerText
				if (newLabel.length > this.truncateLengthValue) { newLabel = `${newLabel.substring(0, this.truncateLengthValue)}...` }
				this.selectedItemsLabelTarget.innerHTML = newLabel
			}
			return
		}

		this.selectedItemsLabelTarget.innerHTML = `${selectedItems.length} ${this.pluralItemNameValue}`
	}

	setClosedEventListener() {
		const dropdownElement = this.element.querySelector('.select-items-dropdown')
		dropdownElement.addEventListener('hide.bs.dropdown', _event => { this.dispatch('closed') })
	}

	selectionChanged() {
		this.setSelectedItemsLabel()
		this.updateResetButton()
	}

	getSelectedItems() {
		if (this.itemInputTargets.length == 0) { return [] }

		return this.itemInputTargets.filter( (input) => input.checked )
	}

	close(event) {
		event.preventDefault()
		const dropdownElement = this.element.querySelector('.select-items-dropdown')
		const bootstrapDropdown = bootstrap.Dropdown.getOrCreateInstance(dropdownElement)
		bootstrapDropdown.hide()
	}

	reset(event) {
		this.itemInputTargets.forEach( (input) => input.checked = false )
		this.selectionChanged()
		this.dispatch('reset', { target: this.element.querySelector('[data-controller="list-search"]') })
	}

	performSearch(event) { if (this.searchIntentValue) { this.submitForm(event) } }

	submitForm(_event) { this.element.closest('form').requestSubmit() }

	updateResetButton() {
		if (this.getSelectedItems().length == 0) {
			this.resetButtonTarget.classList.add('d-none')
			this.selectedItemsLabelTarget.parentNode.classList.add('rounded-end')
		} else {
			this.resetButtonTarget.classList.remove('d-none')
			this.selectedItemsLabelTarget.parentNode.classList.remove('rounded-end')
		}
	}
}
